import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './Contact.css';

const ContactPage = () => {
  return (
    <>
      <Navbar />
      <main className="contact-container">
        <div className="container contact-flex">
          {/* Left: Contact Info */}
          <div className="contact-info">
            <h1 className="section_header text-center">Contact Us</h1>

            <div className="box address-block">
              <h4><strong>Get in touch</strong></h4>
              <div><strong>SmartVizX</strong></div>
              <a href="mailto:hr@smartvizx.com">hr@smartvizx.com</a>

              <div className="mt-4">
                <h4><strong>India Address</strong></h4>
                <p>
                  3th Floor, Plot No. D, 107, D Block, Sector 2,<br />
                  Noida, Uttar Pradesh - 201301, India<br />
                  {/* <a href="tel:+911204259696">+91 120 4259696</a>, <a href="tel:+911204259595">+91 120 4259595</a> */}
                </p>

                <h4><strong>Dubai Address</strong></h4>
                <p>
                  2nd Floor, Business Village Block A,<br />
                  Port Saeed, Deira, Dubai
                </p>

                <h4><strong>Registered Address</strong></h4>
                <p>
                  1st Floor, Greater Kailash-I,<br />
                  New Delhi - 110048
                </p>

                <h4><strong>For Sales Queries</strong></h4>
                <p>
                  Disha Singh<br />
                  <strong>Tel:</strong> <a href="tel:+919818904540">+91 8527417771</a><br />
                  <strong>Email:</strong> <a href="mailto:Disha@smartvizx.com">Disha@smartvizx.com</a>
                </p>
              </div>
            </div>
          </div>

          {/* Right: Map */}
          <div className="map-container">
       <iframe
  className="gmaps-iframe"
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3501.865986062688!2d77.3163165!3d28.583692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390ce459216d57fb%3A0xd29898605298245a!2sSmartvizx!5e0!3m2!1sen!2sin!4v1720954567813"
  allowFullScreen
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  title="SmartVizX"
></iframe>


          </div>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default ContactPage;
